cb.define(['common/common_VM.Extend.js'], function (common) {
  var RM_rm_saleanalysis_filterVM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
      viewmodel.on("afterInit", function () {
        //组织附默认值
        var orgId = cb.rest.AppContext.user.orgId;
        var userOrgs = cb.rest.AppContext.user.userOrgs;
        var defaultValue = { id: orgId };
        var currentOrg = userOrgs && userOrgs.find(function (item) {
          return item.org === orgId;
        });
        if (currentOrg) {
          defaultValue.code = currentOrg.org_code;
          defaultValue.name = currentOrg.org_name;
        }
        //只能参照到当前用户有权限的组织
        if (viewmodel.get("org")) {
          viewmodel.get('org').getFromModel().setValue([defaultValue]);
          viewmodel.get("org").getFromModel().on('beforeBrowse', function (data) {
            var org_ids = [];
            if (userOrgs != null && userOrgs != "" && userOrgs.length != 0) {
              for (var i = 0; i < userOrgs.length; i++) {
                org_ids.push(userOrgs[i].org);
              }
              var conditionOrg = {
                "isExtend": true,
                simpleVOs: []
              };
              conditionOrg.simpleVOs.push({
                field: 'id',
                op: 'in',
                value1: org_ids
              });
              viewmodel.get('org').getFromModel().setFilter(conditionOrg);
            } else {
              cb.utils.alert("无组织权限！", 'error');
              return false;
            }
          });
        }

        
        //退货原因
        if (viewmodel.get("iBackid")) {
          viewmodel.get("iBackid").getFromModel().on('beforeBrowse', function (data) {
            var conditionOrg = {
              "isExtend": true,
              simpleVOs: []
            };
            conditionOrg.simpleVOs.push({
              field: 'reasonTypeId',
              op: 'eq',
              value1: 2
            });
            viewmodel.get('iBackid').getFromModel().setFilter(conditionOrg);
          });
        }

        //现场折扣授权人过滤管理员
        if (viewmodel.get("iSupperOperatorid")) {
          viewmodel.get("iSupperOperatorid").getFromModel().on('beforeBrowse', function (data) {
            var conditionOrg = {
              "isExtend": true,
              simpleVOs: []
            };
            conditionOrg.simpleVOs.push({
              field: 'userType',
              op: 'eq',
              value1: 1
            });
            viewmodel.get('iSupperOperatorid').getFromModel().setFilter(conditionOrg);
          });
        }

        if (viewmodel.get("iEmployeeid")) {
          //选择操作员之前，如果选择门店，按照门店过滤
          viewmodel.get("iEmployeeid").getFromModel().on('beforeBrowse', function (data) {

            var store_ids = [];
            if (viewmodel.get("store").getData().value1 != null && viewmodel.get("store").getData().value1 != "") {
              store_ids = viewmodel.get("store").getData().value1;
            }

            if (store_ids != null && store_ids != "" && store_ids.length != 0) {
              var promise = new cb.promise();
              var proxy = cb.rest.DynamicProxy.create({
                settle: {
                  url: "/bill/ref/getOpsFromStores",
                  method: "POST"
                }
              });
              var params = {
                storeIds: store_ids,
              };
              proxy.settle(params, (err, result) => {
                if (err) {
                  cb.utils.alert(err.message, 'error');
                }
                if (result === undefined || result.length == 0) {
                  cb.utils.alert("没有查询到相关店员！", 'error');
                } else {
                  var conditionOp = {
                    "isExtend": true,
                    simpleVOs: []
                  };
                  conditionOp.simpleVOs.push({
                    field: 'id',
                    op: 'in',
                    value1: result
                  });
                  viewmodel.get('iEmployeeid').getFromModel().setFilter(conditionOp);
                  promise.resolve();
                }
              });
              return promise;
            }
            else {
              viewmodel.get('iEmployeeid').getFromModel().setFilter(null);
            }
          });
        }
      });
    }
  }
  try {
    module.exports = RM_rm_saleanalysis_filterVM_Extend;
  } catch (error) {

  }
  return RM_rm_saleanalysis_filterVM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/RM/RM_rm_saleanalysis_filterVM.Extend.js